(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-letter.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/name-day-by-letter.js');
"use strict";


const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const {
  FixedSizeList
} = ReactWindow;
const {
  namesByFirstLetter
} = svs.tickets_giftshop.gift.giftform.date_selector.namesByDateData;
const {
  DATE_TIME_AND_NAME
} = svs.tickets_giftshop.constants.names;
const {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback
} = React;
const {
  NAME_DAY_BY_LETTER
} = svs.tickets_giftshop.constants.dateSelectorKey;
const getNextChar = (char, availableLetters) => {
  const nextLetter = String.fromCharCode(char.charCodeAt(0) + 1);
  return availableLetters.includes(nextLetter) ? nextLetter : getNextChar(nextLetter, availableLetters);
};
const getPrevChar = (char, availableLetters) => {
  const nextLetter = String.fromCharCode(char.charCodeAt(0) - 1);
  return availableLetters.includes(nextLetter) ? nextLetter : getPrevChar(nextLetter, availableLetters);
};
const Row = _ref => {
  let {
    index,
    data,
    style
  } = _ref;
  const classNames = ['tg-name-day-by-letter-row-item'];
  const {
    isActive,
    selectDate,
    namesByFirstLetterData
  } = data;
  const {
    date,
    name
  } = namesByFirstLetterData[index];
  const [day, month] = date.split('/');
  const active = isActive(day, month, name);
  if (active) {
    classNames.push('tg-name-by-letter-selected fc-white');
  } else {
    classNames.push('fc-black');
  }
  return React.createElement("div", {
    className: "tg-name-day-by-letter-row",
    style: style
  }, React.createElement("a", {
    className: classNames.join(' '),
    href: "",
    onClick: e => {
      e.preventDefault();
      selectDate(day, month, name);
    },
    tabIndex: "0"
  }, React.createElement("div", {
    className: "w50"
  }, React.createElement("b", null, "".concat(name, " "))), React.createElement("div", {
    className: "w50"
  }, React.createElement("span", null, "".concat(day, " ").concat(new Intl.DateTimeFormat('sv-SE', {
    month: 'long'
  }).format(new Date(0, month - 1)))))));
};
const Column = _ref2 => {
  let {
    index,
    data,
    style
  } = _ref2;
  const {
    isActive,
    setLetter,
    availableLetters
  } = data;
  const letterOption = availableLetters[index];
  const active = isActive(letterOption);
  return React.createElement("a", {
    className: "tg-name-day-by-letter-col ".concat(active ? 'tg-name-day-by-letter-col-active' : 'fc-black'),
    href: "",
    onClick: e => {
      e.preventDefault();
      setLetter(letterOption);
    },
    style: style
  }, React.createElement("span", {
    className: "tg-name-day-by-letter-pagination-header"
  }, letterOption));
};
const NameDayByLetter = _ref3 => {
  let {
    date,
    nameDayName = '',
    onInputChange,
    minDate = svs.utils.date.SimpleDate(new Date())
  } = _ref3;
  const listRef = useRef(null);
  const letterListRef = useRef(null);
  const [availableLetters] = useState(() => Object.keys(namesByFirstLetter).sort());
  const [letter, setLetter] = useState(nameDayName && nameDayName[0] || 'A');
  const disableIncrement = letter === 'Ö';
  const disableDecrement = letter === 'A';
  const formatDate = useCallback((day, month) => {
    const date = new Date();
    date.setMonth(month === 1 ? 0 : month - 1);
    date.setDate(day);
    const year = svs.utils.date.SimpleDate(date) < minDate ? date.getFullYear() + 1 : date.getFullYear();
    return "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day);
  }, [minDate]);
  useEffect(() => {
    if (listRef.current && nameDayName) {
      const selectedLetterNames = namesByFirstLetter[letter];
      const nameIndex = selectedLetterNames.findIndex(_ref4 => {
        let {
          name
        } = _ref4;
        return name === nameDayName;
      });
      listRef.current.scrollToItem(nameIndex, 'smart');
    } else {
      listRef.current.scrollToItem(0);
    }
  }, [letter]);
  useEffect(() => {
    if (letterListRef.current) {
      const letterIndex = availableLetters.indexOf(letter);
      letterListRef.current.scrollToItem(letterIndex + 1, 'center');
    }
  }, [availableLetters, letter]);
  const selectDate = useCallback((day, month, name) => {
    const date = formatDate(day, month);
    onInputChange({
      target: {
        value: {
          date,
          time: '08:00',
          nameDayName: name,
          dateSelectorUsed: NAME_DAY_BY_LETTER
        },
        name: DATE_TIME_AND_NAME
      }
    });
  }, [onInputChange, formatDate]);
  const letterData = useMemo(() => ({
    availableLetters,
    setLetter,
    isActive: letterOption => letter === letterOption
  }), [availableLetters, setLetter, letter]);
  const data = useMemo(() => ({
    isActive: (day, month, name) => date === formatDate(day, month) && name === nameDayName,
    selectDate,
    namesByFirstLetterDataCount: Object.keys(namesByFirstLetter[letter]).length,
    namesByFirstLetterData: namesByFirstLetter[letter]
  }), [date, letter, nameDayName, formatDate, selectDate]);
  return React.createElement("div", {
    className: "tg-date-input gutter-sm-2"
  }, React.createElement("div", {
    className: "tg-name-day-by-letter-pagination padding-2"
  }, React.createElement(IconButton, {
    disabled: disableDecrement,
    onClick: e => {
      e.preventDefault();
      setLetter(getPrevChar(letter, availableLetters));
    }
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-left"
  })), React.createElement(FixedSizeList, {
    className: "List tg-name-day-by-letter-list",
    height: 24,
    itemCount: letterData.availableLetters.length,
    itemData: letterData,
    itemSize: 24,
    layout: "horizontal",
    ref: letterListRef,
    style: {
      overflowX: 'hidden'
    },
    width: 285
  }, Column), React.createElement(IconButton, {
    disabled: disableIncrement,
    onClick: e => {
      e.preventDefault();
      setLetter(getNextChar(letter, availableLetters));
    }
  }, React.createElement(Icon, {
    className: "bold",
    icon: "menu-right"
  }))), React.createElement(FixedSizeList, {
    className: "List tg-date-selector-inverted-box-shadow",
    height: 360,
    itemCount: data.namesByFirstLetterDataCount,
    itemData: data,
    itemSize: 36,
    layout: "vertical",
    ref: listRef
  }, Row));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.NameDayByLetter = NameDayByLetter;

 })(window);